<template>
  <v-application v-if="access.setting_options">
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          v-bind:headers="headers"
          v-bind:data="options"
          v-bind:save="save"
          v-bind:row="edit"
          SettingsOptions
          v-bind:remove="remove"
          v-bind:add_button_name="'add_option'"
          v-bind:saveDisabled="
            !is_valid ||
            (option &&
              typeof option.name == typeof 'invan' &&
              option.name.length > 10)
          "
        >
          <v-form v-model="is_valid">
            <v-card-text>
              <v-text-field
                v-model="option.name"
                :label="$t('name')"
                ref="name"
                :rules="[fieldRules.required]"
                autocomplete="off"
              />
            </v-card-text>
          </v-form>
        </v-crud-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="button_size_error" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text">
          Maximum number of buttons is 6
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="button_size_error = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Options from "../../mixins/settings/options";

export default {
  name: "Options",
  mixins: [Options],
  data: () => ({
    option: {
      name: null,
    },
    data: [],
    totalPages: null,
    is_valid: false,
    button_size_error: false,
  }),
  computed: {
    form() {
      return {
        name: this.option.name,
      };
    },
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "name",
          align: "left",
          sortable: false,
          available: true,
        },
      ];
    },
  },
  methods: {
    async remove(items) {
      const indexes = [];
      for (const index in items) {
        indexes.push(items[index]._id);
      }
      await this.$communicator("options_delete_group", {
        params: {
          indexes,
        },
      });
      this.update();
    },
    edit(item) {
      if (item == null) {
        if (typeof this.buttons == typeof [] && this.buttons.length > 5) {
          this.button_size_error = true;
        }
        this.resetForm();
        this.option = {
          name: null,
        };
      } else {
        this.option = this.$copy(item);
      }
    },
    resetForm() {
      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) {
          this.$refs[f].reset();
        }
      });
    },
    async save() {
      if (this.option._id == undefined) {
        await this.$communicator("options_create", {
          params: this.option,
        });
      } else {
        await this.$communicator("options_update", {
          params: this.option,
        });
      }
      this.option = {
        name: null,
      };
      this.resetForm();
      this.update();
    },
    async update() {
      this.optionsGet();
    },
  },
  mounted() {
    this.update();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
